<template>
  <div class="card">
    <div class="card-header">
      <h3 class="mb-0">Computer {{machineSortIndex+1}}</h3>
    </div>
    <div class="card-body">
      <div v-if="loaded">
        <ul class="list-group list-group-flush list my--3">
          <div v-for="(snapshot) in snapshotsOnMachine" :key="snapshot.jobId">
            <live-machine-card-job-item :jobId="snapshot.jobId"></live-machine-card-job-item>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { JobInfoQueryExpansionRequest } from '#/protobuf/job_pb';
import { EntityInfoExpansionRequest } from '#/protobuf/entity_pb';
import { JobGetRequest } from '#/protobuf/service_query_pb';
import LiveMachineCardJobItem from '#/ui/Components/Live/LiveMachineCardJobItem.vue';

export default {
  components: {
    LiveMachineCardJobItem,
  },
  props: {
    machineId: {
      type: String,
      required: true,
    },
    // short hand hack to just title computers by their sort num... i.e. Computer 1, Computer 2
    machineSortIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loaded: false, // we need to load the backing data for the jobs from spanner before we can show the redis supplied snapshot data
    };
  },
  created() {
    // console.debug('MACHINE SNAPSHOTS', this.machineId, this.snapshotsOnMachine);
    this.loadBackingJobs();
  },
  computed: {
    ...mapGetters('live', [
      'snapshotMap',
    ]),
    snapshotsOnMachine() {
      return Array.from(this.snapshotMap.values()).filter((s) => s.machineId === this.machineId);
    },
  },
  methods: {
    // the snapshots we have only contain the update data - we need overview data too
    async loadBackingJobs() {
      console.log('loading backing data for live jobs on machine', this.machineId);
      const entityExpansion = new EntityInfoExpansionRequest();
      entityExpansion.setShouldExpandThumbnail(true);
      const expansionRequest = new JobInfoQueryExpansionRequest();
      expansionRequest.setShouldExpandKeyEntity(entityExpansion);
      expansionRequest.setShouldExpandTags(true);
      expansionRequest.setShouldExpandVolumeMapping(true);
      const request = new JobGetRequest();
      request.setExpansionRequest(expansionRequest);
      request.setJobIdsList(this.snapshotsOnMachine.map((s) => s.jobId));

      const jobPromise = this.$store.dispatch('jobs/loadDetails', request);
      jobPromise.then((response) => {
        console.log('loaded backing data for live jobs on machine', this.machineId, response);
      }).catch((error) => {
        console.log('error loading backing data for live jobs on machine', this.machineId, error);
      }).finally(() => {
        this.loaded = true;
      });
    },
  },
};

</script>
